import React from 'react';
import { AnrufZeile } from '../shared';
import HeroLeadForm from '../HeroLeadForm';

/**
 * HomeHero — Aufmacher der Startseite.
 *
 * Einordnung, Anrufzeile, Formular — mehr nicht. Die Belege stehen in den
 * Fallstudien weiter unten, wo sie im Zusammenhang gelesen werden.
 *
 * Nichts hier traegt `reveal`. Der Aufmacher steht ueber der Falz — eine
 * Einblendung waere dort nicht Wirkung, sondern Wartezeit, und bei
 * vorgerendertem HTML bis zum Start des JavaScripts eine leere Seite.
 * `.hero-home` neutralisiert zusaetzlich jedes `reveal` darunter (homev2.css),
 * damit das auch fuer eingebettete Bausteine wie das Formular gilt.
 */
export default function HomeHero() {
  return (
    <section id="home" className="hero-home">
      {/* shell-wide statt shell: 1240 px, also genau die Breite der
          Navigationsleiste — Logo und Ueberschrift stehen auf derselben
          Kante, ebenso Anfrage-Knopf und rechter Rand des Formulars. */}
      <div className="shell-wide">
        <div className="section-label" style={{ marginBottom: 28 }}>
          <span>Private Immobilienverwaltung</span>
        </div>
        <h1 className="h-display hero-home__titel">
          Weniger Aufwand. Bessere Ergebnisse.
        </h1>
        <p className="lede hero-home__wen">
          Für wachstumsorientierte Investoren, Erben und Treuhänder, denen große Mehrfamilienhäuser
          oder Portfolios im Rhein-Main-Gebiet gehören.
        </p>

        <AnrufZeile />

        <HeroLeadForm />
      </div>
    </section>
  );
}
